export const InfoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <g opacity="0.7" clip-path="url(#clip0_76374_378166)">
    <path d="M7 12.8906C10.2533 12.8906 12.8906 10.2533 12.8906 7C12.8906 3.7467 10.2533 1.10938 7 1.10938C3.7467 1.10938 1.10938 3.7467 1.10938 7C1.10938 10.2533 3.7467 12.8906 7 12.8906Z" stroke="#6A6E6E" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.64062 9.71875H8.35938" stroke="#6A6E6E" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 9.71875V6.54688H6.09375" stroke="#6A6E6E" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 4.50781C6.87487 4.50781 6.77344 4.40638 6.77344 4.28125C6.77344 4.15612 6.87487 4.05469 7 4.05469" stroke="#6A6E6E" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 4.50781C7.12513 4.50781 7.22656 4.40638 7.22656 4.28125C7.22656 4.15612 7.12513 4.05469 7 4.05469" stroke="#6A6E6E" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_76374_378166">
      <rect width="14" height="14" fill="white"/>
    </clipPath>
  </defs>
</svg>`
